import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, SubHeading, Text } from '@components/common';
import { ModalContainer } from '@containers/layout';
import TimeWindow from './TimeWindow';
import DialogBox from '@components/DialogBox';

function TimeWindowModal(props) {
  const { timeframe, show, dismiss, onSubmit, availableWindow } = props;
  const [currentTimeFrame, setTimeFrame] = useState(timeframe);

  useEffect(() => {
    if (timeframe !== currentTimeFrame) {
      setTimeFrame(timeframe);
    }
  }, [timeframe]);

  return (
    <DialogBox show={show} onClickOutside={dismiss}>
      <ModalContainer>
        <SubHeading textAlign="center" fontWeight="bold" mt={4} mb={4}>
          My apartment can be serviced
        </SubHeading>
        <TimeWindow
          mb={4}
          availableWindow={availableWindow}
          value={currentTimeFrame}
          onChange={val => {
            setTimeFrame(val);
          }}
        />
        <Text textAlign="center" fontSize={1} mb={4}>
          We will do our best to accommodate all arrival time requests.
        </Text>
        <Button
          mb={4}
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            onSubmit(currentTimeFrame);
          }}
        >
          Continue
        </Button>
      </ModalContainer>
    </DialogBox>
  );
}

TimeWindowModal.propTypes = {
  timeframe: PropTypes.string,
  availableWindow: PropTypes.array,
  show: PropTypes.bool,
  onSubmit: PropTypes.func,
  dismiss: PropTypes.func
};

export default TimeWindowModal;
